import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Form, Button, Alert, Card, Row, Col, Spinner } from 'react-bootstrap'
import {
  useAdminSystem,
  useCreateAdminSystem,
  useUpdateAdminSystem,
  useDeleteAdminSystem
} from 'api/hooks/use-admin-systems'

const SystemForm = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const isEditing = !!id

  const { data: system, isLoading } = useAdminSystem({ id })
  const createMutation = useCreateAdminSystem({ options: { onSuccess: () => navigate('/admin/systems') } })
  const updateMutation = useUpdateAdminSystem({ id, options: { onSuccess: () => navigate('/admin/systems') } })
  const deleteMutation = useDeleteAdminSystem({ options: { onSuccess: () => navigate('/admin/systems') } })

  const [formData, setFormData] = useState({ name: '', company: '' })

  useEffect(() => {
    if (system) {
      setFormData({ name: system.name || '', company: system.company || '' })
    }
  }, [system])

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (isEditing) {
      updateMutation.mutate(formData)
    } else {
      createMutation.mutate(formData)
    }
  }

  const handleDelete = () => {
    if (window.confirm('Are you sure you want to delete this system?')) {
      deleteMutation.mutate(id)
    }
  }

  const error = createMutation.error || updateMutation.error || deleteMutation.error
  const isSubmitting = createMutation.isLoading || updateMutation.isLoading || deleteMutation.isLoading

  if (isLoading && isEditing) {
    return (
      <div className="text-center p-5">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    )
  }

  return (
    <div>
      <h2>{isEditing ? 'Edit System' : 'Create System'}</h2>

      {error && <Alert variant="danger" className="mt-3">{error.message || 'An error occurred'}</Alert>}

      <Card className="mt-3">
        <Card.Body>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Name *</Form.Label>
                  <Form.Control type="text" name="name" value={formData.name} onChange={handleChange} required />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Company</Form.Label>
                  <Form.Control type="text" name="company" value={formData.company} onChange={handleChange} />
                </Form.Group>
              </Col>
            </Row>

            <div className="d-flex justify-content-between mt-4">
              <div>
                <Button type="submit" variant="primary" disabled={isSubmitting} className="me-2">
                  {isSubmitting ? 'Saving...' : isEditing ? 'Update' : 'Create'}
                </Button>
                <Button type="button" variant="light-primary" onClick={() => navigate('/admin/systems')} disabled={isSubmitting}>Cancel</Button>
              </div>
              {isEditing && (
                <Button type="button" variant="danger" onClick={handleDelete} disabled={isSubmitting}>Delete System</Button>
              )}
            </div>
          </Form>
        </Card.Body>
      </Card>
    </div>
  )
}

export default SystemForm
